export const makeSuburbProfileSection = (s, reportType) => {
  return {
    name: 'SUBURB_PROFILE',
    data: {
      ...s.sectionData,
    }
  };
};